import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';
import BRSpan from '../../General/BRSpan';

const donorStyle = {
  fontSize: '1.5vh',
  fontFamily: 'Lato',
  color: "#000000",
  opacity: 0,
  position:"absolute",
  paddingBottom: '4vh',
  overflow: 'hidden'
}

class DenverDonorList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      donorData: {
        donors: [],
        name: '',
        categoryName: '',
        description: '',
        cycleIndex: 0
      },
      timestamp: null,
      finishedPreRender: false
    };

    this._donorCycleIntervalHandler = null;

    this._donorCategories = _.cloneDeep(this.props.donorCategories);
    this._donorRefs = [];
    this._containerRef = null;
    this._underlineRef = null;
    this._container = {
      height: 0,
      width: 0
    }

    // this._donorListCycleSeconds = 0;
    this._donorIndex = 0;
    this._categoryIndex = 0;
    this._lastPageCount = 0;


    // this._endOfDonorLoop = true;

    // this._donorCols = 2;
    // this._donorRows = 6;
    // this._verticalSpace = 1;
    // this._horizontalSpace = 1;

    // this._donors = [];

  }

  componentDidMount() {
    try {
      document.addEventListener("keydown", this.handleKeyDown);
      setTimeout(() => {
        // console.log("timeout done");
        // console.log("this._donorRefs.length", this._donorRefs.length);
        // console.log("this.state.finishedPreRender", this.state.finishedPreRender);
        //calls after one full render
        if (this._donorRefs.length > 0 && this.state.finishedPreRender === false) {
          let counter = -1;
          this._donorCategories.map( (cat) => {
            cat.donors.map( (donor) => {
              counter ++; 
              donor.height = this._donorRefs[counter].offsetHeight;
              donor.width = this._donorRefs[counter].offsetWidth;
              return null;
            });
            return null;
          })

          this._container = {
            width: this._containerRef.offsetWidth,
            height: this._containerRef.offsetHeight
          }
          // console.log("refs", this._donorRefs);
          // console.log("this._donorCategories", this._donorCategories);
          // console.log("this._container", this._container);
          
          this.setState({
            finishedPreRender: true
          });
        }

        const cat = this._donorCategories[this._categoryIndex];
        const mainHeader = _.get(cat, 'contents.custom_fields.main_header.val', '');
        const subcategoryName = _.get(cat, 'contents.custom_fields.subcategory_name.val', '');
        const fontSize = _.get(cat, 'contents.custom_fields.font_size.val.value');
        const description = _.get(cat, 'contents.custom_fields.subhead_text.val', "");

        // const subheadOps = _.get(cat, 'contents.custom_fields.subhead.val.ops');
        // const subheadOpsInstance = new QuillDeltaToHtmlConverter(subheadOps, {});
        // const subheadOpsRichText = subheadOpsInstance.convert();
        this.setState({
          donorData: {
            name,
            mainHeader,
            subcategoryName,
            description: description,
            fontSize
          }
        });

        this.startCycle();
      }, 1000);
    } catch(e) {
      console.log(e);
    }
  }

  componentWillUnmount() {
    clearTimeout(this._donorCycleIntervalHandler);
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "c":
      console.log("a c")
        this.cycleDonorIndex();
        break;
      default:
        break;
    }
  }

  getCategoryStyle = (category, field, style = {}) => {
    style.fontSize = _.get(category, 'contents.custom_fields.'+ field +'.fontSize', 3) + "vh";
    style.fontStyle = _.get(category, 'contents.custom_fields.'+ field +'.fontStyle', "Normal").toLowerCase();
    style.fontFamily= _.get(category, 'contents.custom_fields.'+ field +'.fontFamily', "Lato");
    style.fontWeight = _.get(category, 'contents.custom_fields.'+ field +'.fontWeight', "100");
    style.paddingBottom = _.get(category, 'contents.custom_fields.'+ field +'.height', 5) + "vh";
    style.lineHeight = _.get(category, 'contents.custom_fields.'+ field +'.lineHeight', 3.5) + "vh";
    style.textAlign = _.get(category, 'contents.custom_fields.'+ field +'.justification', 'left').toLowerCase();
    style.fontColor = _.get(category, 'contents.custom_fields.'+ field +'.fontColor', '#000000').toLowerCase();

    return style;
  }

  preRenderDonors = () => {
    let flatDonors = []
    this._donorCategories.map( (category) => {
      let columns = _.get(category, 'contents.custom_fields.columns.val', 3);
      let columnWidth = this.props.listWidth / columns;
      category.donors.map( (donor) => {
          let donorStyleCopy = _.cloneDeep(donorStyle);
          donorStyleCopy.opacity = 0;
          donor.style = this.getCategoryStyle(category, "donor_name_style", donorStyleCopy);
          donor.style.width = columnWidth * .9;
          flatDonors.push(donor);
          return null;
        })
      return null;
    })
    return (
      flatDonors.map((donor, i) => {
        return (
          <div key={i} ref={el => this._donorRefs[i] = el} style={{ ...donor.style }}><BRSpan str={donor.name} /></div>
        )
      })
    )
  }

  getAllDonorsHeight = () => {
    console.log('this._donorCategories', this._donorCategories);
  }
  
  startCycle = () => {
    const donorCategory = this._donorCategories[this._categoryIndex];
    const timeout = _.get(donorCategory, 'contents.custom_fields.cycle_timeout.val', 10);
    clearTimeout(this._donorCycleIntervalHandler);
    this._donorCycleIntervalHandler = setTimeout(() => {
      this.cycleDonorIndex();
      this.startCycle();
    }, timeout * 1000);
  }

  cycleDonorIndex = () => {
    if (this._donorIndex + this._lastPageCount >= this._donorCategories[this._categoryIndex].donors.length){
      this._donorIndex = 0;
      this._categoryIndex++;
      if (this._categoryIndex >= this._donorCategories.length){
        if (this.props.allCategoriesLooped){
          this.props.allCategoriesLooped()
        }
        this._categoryIndex = 0
      }
    }
    else{
      this._donorIndex += this._lastPageCount;
    }

    const cat = this._donorCategories[this._categoryIndex];
    const mainHeader = _.get(cat, 'contents.custom_fields.main_header.val', '');
    const subcategoryName = _.get(cat, 'contents.custom_fields.subcategory_name.val', '');
    const fontSize = _.get(cat, 'contents.custom_fields.font_size.val.value');
   
    // const subheadOps = _.get(cat, 'contents.custom_fields.subhead.val.ops');
    // const subheadOpsInstance = new QuillDeltaToHtmlConverter(subheadOps, {});
    // const subheadOpsRichText = subheadOpsInstance.convert();
    const description = _.get(cat, 'contents.custom_fields.subhead_text.val', "");
    this.setState({
      donorData: {
        name,
        mainHeader,
        subcategoryName,
        description: description,
        fontSize
      }
    });
  }

  renderNames = () => {
    const category = this._donorCategories[this._categoryIndex];
    let columns = _.get(category, 'contents.custom_fields.columns.val', 3);
    let currentHeight = 0;
    let currentColumn = 1;
    let drawDonors = [];
    let columnWidth = this._container.width / columns
    this._lastPageCount = 0;

    for (var a = this._donorIndex; a < this._donorCategories[this._categoryIndex].donors.length; a++) {
      let donor = this._donorCategories[this._categoryIndex].donors[a];
      //fits in column
      if ((currentHeight + donor.height) > this._container.height) {
        if (currentColumn < columns) {
          //reset for new column
          currentHeight = 0;
          currentColumn++;
        }
        else {
          break
        }
      }

      donor.top = currentHeight
      donor.column = currentColumn
      currentHeight += donor.height
      drawDonors.push(donor);
      this._lastPageCount++;
    }

    let clonedDonorStyle = _.cloneDeep(donorStyle);
    clonedDonorStyle = this.getCategoryStyle(category, 'donor_name_style', clonedDonorStyle);

    return(
      drawDonors.map( (item, i) => {
        return(
          <div key={i} style={{ ...clonedDonorStyle, maxWidth: columnWidth, top: item.top, left: (item.column - 1) * columnWidth, opacity: 1, width: columnWidth * .9 }}><BRSpan str={item.name} /><br /></div>
        )
      })
    )
  }

  render(){
    let sDims = {
      height: this.props.height,
      width: this.props.width
    }
    sDims.fsTitle = sDims.height * this.props.fsTitleModifier || 0.045;
    sDims.fsTitleSub = sDims.height * 0.0275;
    if (this.props.content.settings.custom_vars) {
      if (this.props.content.settings.custom_vars.ParentGroupFontSize) {
        sDims.fsTitle = sDims.height * this.props.content.settings.custom_vars.ParentGroupFontSize * .01;
      }
      if (this.props.content.settings.custom_vars.GroupFontSize) {
        sDims.fsTitleSub = sDims.height * this.props.content.settings.custom_vars.GroupFontSize * .01;
      }
    }

    sDims.fsSubheader = sDims.height * this.props.fsSubheaderModifier;
    
    const customFsNames = this.state.donorData.fontSize && !isNaN(this.state.donorData.fontSize) ? this.state.donorData.fontSize : 20;
    
    sDims.fsNames =  (customFsNames / this.props.targetHeight) * sDims.height;
    
    sDims.yOffsetTitle = sDims.height *  this.props.yOffsetTitleModifier;
    sDims.yOffsetSubheader = sDims.height *  this.props.yOffsetSubheaderModifier;
    sDims.yOffsetSubheaderUnderline = sDims.height *  this.props.yOffsetSubheaderUnderlineModifier;
    sDims.yOffsetNames = sDims.height *  this.props.yOffsetNamesModifier;
    // return null;
    return(
      <div className="denver-donor-list" style={{ position: "absolute", width: this.props.width, height: this.props.height, left: this.props.left }}>
        {/* Donor list name, category */}
        <CSSTransitionGroup
          component='div'
          transitionName='slowfade'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={'header-' + this._categoryIndex}>
            <div style={{ ...this.props.style, top: sDims.yOffsetTitle, width: this.props.width * .9, height: this.props.height * .05 }}>
              {this.state.donorData && this.state.donorData.mainHeader ?
                <span>
                  <span style={{ fontFamily: 'Lato Bold', width: this.props.titleWidthModifier * this.props.width, letterSpacing: '2.2px', fontSize: sDims.fsTitle }}>{this.state.donorData.mainHeader}</span>
                  {this.props.hideDonorListName ? '' : <span style={{ marginLeft: '1.75vw', letterSpacing: '1.7px', fontWeight: 'bold', fontSize: sDims.fsTitleSub }}>{" " + this.state.donorData.subcategoryName}</span>}
                </span> : <span />}
            </div>
          </div>
        </CSSTransitionGroup>

        {/* Group Description */}
        <CSSTransitionGroup
          component='div'
          transitionName='slowfade'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={'description-' + this.state.donorData.cycleIndex} style={{ position: "absolute", top: sDims.yOffsetSubheader }}>
            {/* Group Description */}
            <div className="denver-donor-list__description-container" style={{ ...this.props.style, fontSize: sDims.fsSubheader, opacity: 1, width: this.props.width * this.props.descriptionWidthModifier/* * .75*/, maxHeight: this.props.height * .1, lineHeight: 1.5, position: "relative", marginBottom: "1.38vh" , overflow: "hidden", height: "auto" }}>
              {this.state.donorData.description ? <span style={{ fontSize: this.props.subHeaderFontSize, fontFamily: "Lato" }}>{this.state.donorData.description}</span> : <span />}
            </div>

            {/* Underline */}
            <div style={{ ...this.props.style, backgroundColor: 'black', opacity: 1, width: this.props.width * this.props.subheaderUnderlineWidthModifier, height: '1px', position: "relative" }} />
          </div>
        </CSSTransitionGroup>

        <div ref={el => this._containerRef = el} style={{...this.props.style, zIndex: 100, top: this.props.listTopOffset, opacity: 1, height: this.props.listHeight, width: this.props.listWidth }}>
        <CSSTransitionGroup
          component='div'
          transitionName='slowfade'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          {this.state.finishedPreRender ? 
            <div key={"donor-index" + this._donorIndex + "-category-index-" + this._categoryIndex}>
              {this.renderNames()}
            </div>
            :
            this.preRenderDonors()}
        </CSSTransitionGroup>
      </div>
    </div>
    )
  }

}

export default DenverDonorList;


// WEBPACK FOOTER //
// ./src/Components/Theme/Denver/DenverDonorList.js